import { Box, Text } from '@factorialco/deprecated-design-system'
import { Search } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency, { isCurrency } from 'modules/core/lib/money'

import BreakdownDayRow, {
  DayConceptExclusions,
} from 'modules/expenses/components/expenses/New/PerDiemWizard/components/BreakdownDayRow'
import { PerDiemDay } from 'modules/expenses/components/expenses/New/PerDiemWizard/form/context'
import FormBlock from 'modules/expenses/components/expenses/New/PerDiemWizard/FormBlock'

interface DailyBreakdownProps {
  days: Array<PerDiemDay | null> | null
  totalAmountCents: number
  currency: string
  locale: string
  isLoading?: boolean
  conceptExclusionsByDate?: Record<string, DayConceptExclusions>
}

const DailyBreakdown = ({
  days,
  totalAmountCents,
  currency,
  locale,
  isLoading = false,
  conceptExclusionsByDate,
}: DailyBreakdownProps) => {
  return (
    <FormBlock
      divider
      collapsedTitle={i18n.t(
        'expenses_v2.forms.germany_per_diem_modal.breakdown.see_full_breakdown'
      )}
      expandedTitle={i18n.t(
        'expenses_v2.forms.germany_per_diem_modal.breakdown.hide_full_breakdown'
      )}
      collapsible
      defaultCollapsed
      titleIcon={Search}
    >
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text.Normal size="300" weight="semibold" color="grey1000">
          {i18n.t('expenses_v2.forms.germany_per_diem_modal.per_diem_total')}
        </Text.Normal>
        <Text.Normal size="300" weight="semibold" color="grey1000">
          {isCurrency(currency)
            ? MoneyWithCurrency({
                amount: totalAmountCents,
                currency: currency,
                locale: locale,
              })
            : `${totalAmountCents / 100} ${currency}`}
        </Text.Normal>
      </Box>

      {isLoading && (
        <Box padding="s16" justifyContent="center">
          <Text.Normal size="200" color="grey600">
            {i18n.t('expenses_v2.forms.germany_per_diem_modal.breakdown.loading')}
          </Text.Normal>
        </Box>
      )}

      {days && days.length > 0 && (
        <Box flexDirection="column" gap="s24" style={{ marginTop: 'var(--spacing-s8)' }}>
          {days
            .filter((day): day is NonNullable<typeof day> => day !== null && day !== undefined)
            .map((day) => (
              <BreakdownDayRow
                key={day.date}
                day={day}
                currency={currency}
                locale={locale}
                conceptExclusions={conceptExclusionsByDate?.[day.date]}
              />
            ))}
        </Box>
      )}
    </FormBlock>
  )
}

export default DailyBreakdown
